<template>
  <div><div class="ntMain__head flexbox">
     <span class="back" @click="$router.go(-1)"><i class="iconfont icon-arrL"></i></span>
   <h2 class="hdtit flex1">收藏</h2><span class="link"><i class="iconfont icon-vdots"></i></span>
     </div><div class="ntMain__cont flex1 flexbox flex-col">
       敬请期待...
    </div>
 </div>
</template>
